import { saveAs } from 'file-saver'
import { fetchAttachedResources } from '../fetch/fetchAttachedResources'
import { getDocWithPagesAndImages } from './getDocWithPagesAndImages'
import { hideLoader } from '../loader'
import { getDocWithAppendedPdfs } from './getDocWithAppendedPdfs'
import { sanitizeFilename, removeTrailingUnderscores } from '../../utils/filenameSanitizer'

/**
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 */
export const saveContentAsPdf = constructionLog => 
  fetchAttachedResources(constructionLog)
    .then(async attachedResources => {
      let jsPdfDoc = getDocWithPagesAndImages(constructionLog, attachedResources)
      let pdfLibDoc = await getDocWithAppendedPdfs(jsPdfDoc, attachedResources)

      await savePdfLibDoc(pdfLibDoc, constructionLog)
      hideLoader()
    })

/**
 * Generates filename for construction log PDF download
 * Format for single page: strana_br.{number}_dnevnik_{project_name}_{group_of_works}.pdf
 * Format for whole log: dnevnik_{project_name}_{group_of_works}.pdf
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 * @returns {string}
 */
function generateFilename(constructionLog) {
  const projectName = constructionLog.project_name || ''
  const groupOfWorks = constructionLog.group_of_works || ''
  
  const sanitizedProjectName = sanitizeFilename(projectName)
  const sanitizedGroupOfWorks = sanitizeFilename(groupOfWorks)
  
  // Check if this is a whole log download (multiple pages) or single page
  const isWholeLog = constructionLog.log_pages && constructionLog.log_pages.length > 1
  
  let filename
  if (isWholeLog) {
    // Whole log: remove page number prefix
    filename = `dnevnik_${sanitizedProjectName}_${sanitizedGroupOfWorks}.pdf`
  } else {
    // Single page: include page number
    const pageNumber = constructionLog.log_pages && constructionLog.log_pages.length > 0 
      ? constructionLog.log_pages[0].number 
      : ''
    filename = `strana_br.${pageNumber}_dnevnik_${sanitizedProjectName}_${sanitizedGroupOfWorks}.pdf`
  }
  
  // Remove trailing underscores before .pdf
  filename = removeTrailingUnderscores(filename, '.pdf')
  
  return filename
}

/**
 * @param {PDFDocument} pdfLibDoc 
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 */
async function savePdfLibDoc (pdfLibDoc, constructionLog) {
  const pdfBytes = await pdfLibDoc.save()
  let blob = new Blob([pdfBytes])
  const filename = generateFilename(constructionLog)
  saveAs(blob, filename)
}
